import { Translations } from "@shared/i18n/TranslationsEnum";

const en = {
  [Translations.Common]: {
    "errors": {
      "noProjectSelected": "No project selected",
      "noHubSelected": "No Hub selected"
    },
    "actions": {
      "cancel": "Cancel",
      "close": "Close",
      "retry": "Retry"
    },
    "searchField": {
      "placeholder": "Search in Files"
    },
    "fileActions": {
      "upload": {
        "emptyFileUploadError": "You can't upload an empty file",
      },
      "get": {
        "error": "An error occurred while loading the files"
      }
    },
    "secondaryFileActions": {
      "get": {
        "error": "An error occurred while loading the secondary files"
      },
    },
    "folderActions": {
      "get": {
        "error": "An error occurred while loading the folder structure"
      }
    },
    "folderTree": {
      "rootNodeName": "Files",
      "emptyTree": {
        "title": "No folders yet",
        "action": "Create a folder"
      }
    },
    "edms": {
      "connectorList": {
        "expiredTokens": {
          "title": "Authentication expired",
          "subTitle": "Login to your data source to regain access to your files",
          "action": "Login"
        },
        "resourceNotFound": {
          "title": "The folder you linked is no longer available",
          "subTitle": "It appears to have been deleted or moved",
          "bannerTitle": "The linked folder is no longer available"
        }
      },
      "linkedFolder": {
        "get": {
          "error": "An error occurred while loading your files. Please try again."
        },
        "error": {
          "refreshPage": "Refresh the page"
        }
      }
    },
    [Translations.ForbiddenAccess]: {
      "header": "You don’t have access to the file manager",
        "body": "If you need access to the file manager, ask your project’s administrator for it"
    },
    [Translations.HubExpired]: {
      "header": "The hub subscription has expired",
        "body": "Please update you subscription"
    }
  },
};

export default en;